export default "__VITE_ASSET__103cef39__"